




import { Component, Mixins } from "vue-property-decorator";

import { WidgetMixin } from "./mixins";

@Component
export default class WBreak extends Mixins(WidgetMixin) {}
